import { CSSProperties } from 'react'
import { gold } from '@ant-design/colors'
import { theme } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons'
import { FieldWarning } from '../inputSanityModel'
import CoachingDisclosure from './CoachingDisclosure'
import './InputWarning.css'

type Props = {
  warning: FieldWarning | null
}

const InputWarning = ({ warning }: Props) => {
  const { token } = theme.useToken()

  if (warning === null) {
    return null
  }

  const coaching = warning.coaching

  const palette = {
    '--budget-warning-color': gold[7],
    '--budget-warning-gap': `${token.marginXXS}px`,
    '--budget-warning-font-size': `${token.fontSizeSM}px`
  } as CSSProperties

  return (
    <div className="budget-input-warning" style={palette}>
      <p className="budget-input-warning-text" role="status">
        <FontAwesomeIcon icon={faCircleExclamation} />
        <span>{warning.text}</span>
      </p>

      {coaching !== undefined && (
        <div className="budget-input-warning-coaching-slot">
          <CoachingDisclosure coaching={coaching} />
        </div>
      )}
    </div>
  )
}

export default InputWarning
